import React from 'react';
export function StoryPullQuote() {
  return <section className="w-full bg-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-413" data-mp="1i7pj4lxd9zgu">
      <div className="max-w-4xl mx-auto" data-id="element-414" data-mp="3g95ac12sx3bh">
        <figure className="border-l-4 border-brand-orange pl-6 md:pl-8" data-id="element-415" data-mp="3baty5jp1agq3">
          <blockquote className="text-xl md:text-2xl font-medium italic text-brand-navy leading-relaxed" data-id="element-416" data-mp="3bb3oj8dzqpwb">
            "Michael is the type of leader that makes any meeting, project, or
            team better. He's incredibly skilled at asking the right questions
            to frame the task or problem at hand correctly, and then drives the
            team to deliver great results."
          </blockquote>
          <figcaption className="mt-4 flex items-center gap-3" data-id="element-417" data-mp="3u7lcdeppy5na">
            <img src="https://cdn.magicpatterns.com/uploads/s6sSQXnGtE4Gjo5PBGmyK6/image.jpg" alt="Laura Callahan" className="w-10 h-10 rounded-full object-cover flex-shrink-0" data-id="element-418" data-mp="3q7b7k5dnxla0" />
            <span className="text-base text-brand-gray-light" data-id="element-419" data-mp="lrrxt5ey748v">
              <span className="font-bold text-brand-navy" data-id="element-420" data-mp="38ruj0u66ykw5">Laura Callahan</span>
              , Product Manager (reported to Michael)
            </span>
          </figcaption>
        </figure>
      </div>
    </section>;
}